export enum CHART_SIZES {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large',
}
